import { gql } from 'graphql-tag';
import {
  ResourceRequestStatus,
  SpecificResourceRequestFragmentDoc
} from '~/types';

import {
  specificResourceAllocationFragment,
  specificResourceAllocationUserFragment,
  specificResourceAllocationTimeOffFragment,
  specificResourceAllocationHolidaysFragment
} from '~/modules/resourcing/common/fragments';
import { useUpdateCompletedResourceAllocationProjectCacheOnAddWithProposedRequest2 } from '~/modules/projects/resourcing-plan/ResourceRequestChart/components/ResourceAllocationChart/hooks/useUpdateCompletedResourceAllocationCache';

import { mapToServiceRequest } from '../../util';

export const COMPLETE_RESOURCE_REQUEST = gql`
  mutation markResourceRequestAsComplete(
    $input: MarkResourceRequestAsCompleteInput!
    $chartDateRange: DateRangeInput = null
    $showHolidays: Boolean = false
    $showTimeOff: Boolean = false
  ) {
    markResourceRequestAsComplete2(input: $input) {
      resourceRequest {
        ...SpecificResourceRequest
        resourceAllocations {
          ...SpecificResourceAllocation
          role {
            uri
            id
            displayText
          }
          user {
            ...SpecificResourceAllocationUser
            ...SpecificResourceAllocationTimeOff
            ...SpecificResourceAllocationHolidays
          }
        }
      }
    }
  }
  ${SpecificResourceRequestFragmentDoc}
  ${specificResourceAllocationFragment}
  ${specificResourceAllocationUserFragment}
  ${specificResourceAllocationTimeOffFragment}
  ${specificResourceAllocationHolidaysFragment}
`;

export const getCompleteResourceRequestQueries = () => {
  return {
    mutationDocument: COMPLETE_RESOURCE_REQUEST
  };
};

export const invokeMarkResourceRequestAsComplete = markResourceRequestAsComplete => ({
  allocationChartRef,
  chartDateRange,
  chartSelectedTab,
  cacheUpdateFunctions,
  request,
  requestAccessLevel,
  showHolidays,
  showTimeOff
}) => {
  const requestParams = {
    request,
    responseType: 'markResourceRequestAsComplete2',
    responseTypeName: 'MarkResourceRequestAsCompleteResult',
    requestStatus: ResourceRequestStatus.Complete,
    chartSelectedTab,
    requestAccessLevel,
    refetchQueries: ['getProjectTotalsBySlug']
  };

  allocationChartRef?.current.setResourceRequestAcceptedLoading(true);

  markResourceRequestAsComplete(
    mapToServiceRequest({
      ...requestParams,
      cacheUpdate: useUpdateCompletedResourceAllocationProjectCacheOnAddWithProposedRequest2(
        {
          allocationChartRef
        }
      ),
      chartDateRange,
      showTimeOff: Boolean(showTimeOff),
      showHolidays: Boolean(showHolidays),
      allocationChartRef,
      cacheUpdateFunctions
    })
  );
};
